import AnalyticsEngineGTMBase from "../../../../src/common/analytics/engines/analyticsEngineGTMBase";
import * as eventNames from "../../../../src/common/analytics/analyticsevents";
import { labelToDate, stripHtm } from "../../../../src/common/utilities/utils";

export default class AnalyticsEngineGTM extends AnalyticsEngineGTMBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    //page views
    this._analyticsManagerBase.on(eventNames.VIEW_PAGE, (data) => {
      this._sendPageView("PAGE_VIEW", data, "Classic");
    });
    this._analyticsManagerBase.on(
      eventNames.VIEW_PAGE_IN_BACKGROUND,
      (data) => {
        this._sendPageView("PAGE_VIEW", data, "Background");
      }
    );
    this._analyticsManagerBase.on(eventNames.VIEW_ARTICLE_ALB, (data) => {
      this._sendArticleView("ARTICLE_VIEW", data, true);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_PRINT_TEXT_ALB, (data) => {
      data.target = "impression";
      data.category = "lightbox";
      this._sendClickAction("CLICK_CTA", data, true);
      this._sendArticleView("ARTICLE_PRINT", data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PRINT_IMAGE_ALB,
      (data) => {
        data.target = "impression";
        data.category = "lightbox";
        this._sendClickAction("CLICK_CTA", data, true);
        this._sendArticleView("ARTICLE_PRINT", data);
      }
    );
    this._analyticsManagerBase.on(eventNames.OPENED_HOME, (data) => {
      this._sendUserInfo("USER_INFORMATIONS", data);
    });
    this._analyticsManagerBase.on(eventNames.AUTHORIZED, (data) => {
      this._sendUserInfo("USER_INFORMATIONS", data, true);
    });
    this._analyticsManagerBase.on(eventNames.AUTHENTICATED, (data) => {
      this._sendUserInfo("USER_INFORMATIONS", data, true);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_SIGNOUT_TOPNAV, (data) => {
      this._sendUserInfo("USER_INFORMATIONS", data, true);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_PRINT_PDF, (data) => {
      data.target = "page_journal";
      data.category = "impression";
      this._sendClickAction("CLICK_CTA", data, true);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_CATEGORY_READER,
      (data) => {
        data.category = "lineaire";
        this._sendClickAction("CLICK_CTA", data, true);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_FULLPDFDOWNLOAD_READER,
      (data) => {
        data.target = "journal";
        data.category = "telechargement";
        this._sendClickAction("CLICK_CTA", data, true);
      }
    );

    this._analyticsManagerBase.on(eventNames.CLICKED_FACEBOOK_SHARE, (data) => {
      data.target = "partager facebook";
      data.category = "lightbox";
      this._sendClickAction("CLICK_CTA", data, true);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_WHATSAPP_SHARE, (data) => {
      data.target = "partager whatsapp";
      data.category = "lightbox";
      this._sendClickAction("CLICK_CTA", data, true);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_TWITTER_SHARE, (data) => {
      data.target = "partager twitter";
      data.category = "lightbox";
      this._sendClickAction("CLICK_CTA", data, true);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_MAIL_SHARE, (data) => {
      data.target = "partager mail";
      data.category = "lightbox";
      this._sendClickAction("CLICK_CTA", data, true);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_FULLSCREEN_READER,
      (data) => {
        data.target = "plein_ecran";
        data.category = "";
        this._sendClickAction("CLICK_CTA", data, true);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_ENRICHEMENT_ALB,
      (data) => {
        data.target = "video_launch";
        data.category = "lightbox";
        this._sendClickAction("CLICK_CTA", data, true);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_HOME_ICON_READER,
      (data) => {
        data.target = "retour_tlg";
        data.category = "";
        this._sendClickAction("CLICK_CTA", data, true);
      }
    );

    this._analyticsManagerBase.on(eventNames.CLICKED_HOME_SIDEBAR, (data) => {
      data.target = "retour_tlg";
      data.category = "";
      this._sendClickAction("CLICK_CTA", data, true);
    });

    this._analyticsManagerBase.on(
      eventNames.CLICKED_HAMBURGER_READER,
      (data) => {
        data.target = "ouvrir";
        data.category = "burger";
        this._sendClickAction("CLICK_CTA", data, true);
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_HAMBURGER_HOME, (data) => {
      data.target = "ouvrir";
      data.category = "burger";
      this._sendClickAction("CLICK_CTA", data, true);
    });
  }

  _sendPageView(eventName, data, type, articleId = undefined) {
    let regionCode = "";
    const {
      eventData: {
        bundle: { publication },
      },
    } = data;
    const {
      eventData: { bundle },
    } = data;
    const pages = bundle.publication.pages;
    const downloadToken = bundle.downloadToken;

    if (downloadToken) {
      regionCode = downloadToken.slice(-2);
    }
    if (pages.length > 0) {
      pages.forEach((page) => {
        const dataToSend = {
          event: eventName,
          CONTENT_SITE: "Le Télégramme - Liseuse webapp",
          CONTENT_TYPE: type,
          CONTENT_URL: articleId
            ? `${page.pageReference}/${articleId}`
            : page.pageReference,
          EDITION_J: regionCode,
          DATE_PARUTION: this._beautifyDate(bundle.bundleDateTime),
          SECTION_LINEAIRE: page.section,
          TYPE_SUPPORT:
            publication.type == "Main" ? "Journal" : publication.type,
        };
        this.sendToDatalayer(dataToSend);
      });
    }
  }

  _sendArticleView(eventName, data, sendPageview = false) {
    const {
      eventData: {
        bundle: {
          publication: { pages },
        },
      },
    } = data;
    const articles = pages[0].articles;
    const title = stripHtm(articles[0].title);
    const articleId = articles[0].articleReference;
    let dataToSend = {};
    dataToSend = {
      event: eventName,
      ARTICLE_TITLE: title,
      ARTICLE_ID: articleId,
    };

    this.sendToDatalayer(dataToSend);
    if (sendPageview) {
      this._sendPageView("PAGE_VIEW", data, "Lightbox", articleId);
    }
  }

  _sendUserInfo(eventName, data) {
    const { user } = data;
    const dataToSend = {
      event: eventName,
      ID_SSO: user ? user.userReference : undefined,
      USER_AGENT: navigator.userAgent,
    };
    this.sendToDatalayer(dataToSend);
  }

  _sendClickAction(eventName, data) {
    const dataToSend = {
      event: eventName,
      CTA_TARGET: data.target ? data.target : data.selectedSection,
      CTA_CATEGORY: data.category,
    };
    this.sendToDatalayer(dataToSend);
  }

  _beautifyDate(uglyDate) {
    return labelToDate(uglyDate, "fr", "L");
  }
}



// WEBPACK FOOTER //
// ./clients/tel-tel/js/engines/analyticsEngineGTM.js